(function () {
  var LIMIT_CJK = 40;
  var LIMIT_LATIN = 70;

  // ---- 共用：字數規則 ----

  // 內容裡出現中日文字元就用 40 字上限，全英數用 70
  function limitFor(text) {
    return /[\u4e00-\u9fff\u3040-\u30ff\uff00-\uffef]/.test(text) ? LIMIT_CJK : LIMIT_LATIN;
  }

  function refreshCount(wrap) {
    if (!wrap) return;
    var input = wrap.querySelector('.card-message__input');
    if (!input) return;

    var len = input.value.length;
    var limit = limitFor(input.value);
    var over = len > limit;

    var countEl = wrap.querySelector('.card-message__count');
    var limitEl = wrap.querySelector('.card-message__limit');
    if (countEl) countEl.textContent = len;
    if (limitEl) limitEl.textContent = limit;

    var counterEl = wrap.querySelector('.card-message__counter');
    if (counterEl) counterEl.hidden = len === 0;

    wrap.classList.toggle('is-over', over);
  }

  function toggleMessageField(wrap, needs) {
    if (!wrap) return;
    wrap.hidden = !needs;

    var input = wrap.querySelector('.card-message__input');
    if (!input) return;

    input.disabled = !needs; // 停用才不會送出空的「卡片內容」
    input.required = !!needs;
  }

  // ---- 共用：錯誤訊息與驗證 ----

  function showFieldError(wrap, message) {
    var el = wrap && wrap.querySelector('.card-message__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearFieldError(wrap) {
    var el = wrap && wrap.querySelector('.card-message__error');
    if (el) el.hidden = true;
  }

  // 加購區塊的錯誤訊息放在另一個元素，單獨處理
  function clearUpsellError(root) {
    var el = root && root.querySelector('.cart-upsell__error');
    if (el) el.hidden = true;
  }

  // 有問題回傳錯誤訊息，沒問題回傳 null
  function validateMessage(input) {
    var value = input.value.trim();
    if (!value) return '請填寫卡片代寫內容。';
    if (value.length > limitFor(value)) {
      return '卡片內容超過字數上限（中文 40 字／英文 70 characters）。';
    }
    return null;
  }

  // ---- 字數即時更新（兩邊共用）----

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('.card-message__input');
    if (!input) return;

    var wrap = input.closest('.card-message');
    refreshCount(wrap);
    clearFieldError(wrap);
    clearUpsellError(input.closest('.cart-upsell')); // 修正一：打字時清掉加購區塊的錯誤
  });

  // ---- 加購區塊：換包裝選項 ----

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('.cart-upsell__select');
    if (!select) return;

    var root = select.closest('.cart-upsell');
    var opt = select.options[select.selectedIndex];

    var priceEl = root.querySelector('.cart-upsell__price');
    if (opt && priceEl) priceEl.textContent = opt.dataset.price;

    toggleMessageField(
      root.querySelector('.card-message'),
      opt && opt.dataset.needsMessage === 'true'
    );

    clearUpsellError(root); // 修正二：換選項時清掉舊的錯誤
  });

  // ---- 商品頁：切換變體 ----

  document.addEventListener('change', function (e) {
    var picker = e.target.closest && e.target.closest('variant-selects');
    if (!picker) return;

    var chosen =
      picker.querySelector('input[type="radio"]:checked') || picker.querySelector('select');
    var label = chosen ? chosen.value : '';

    toggleMessageField(
      document.querySelector('.product__info-container .card-message'),
      label.indexOf('代寫') !== -1
    );
  });

  // ---- 加購按鈕 ----

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.cart-upsell__button');
    if (!btn) return;

    var root = btn.closest('.cart-upsell');
    var select = root.querySelector('.cart-upsell__select');
    var errorEl = root.querySelector('.cart-upsell__error');
    var msgWrap = root.querySelector('.card-message');
    var msgInput = root.querySelector('.card-message__input');

    var needsMessage = msgWrap && !msgWrap.hidden;

    errorEl.hidden = true;

    if (needsMessage) {
      var invalid = validateMessage(msgInput);
      if (invalid) {
        errorEl.textContent = invalid;
        errorEl.hidden = false;
        msgInput.focus();
        return;
      }
    }

    var item = { id: Number(select.value), quantity: 1 };
    if (needsMessage) item.properties = { 卡片內容: msgInput.value.trim() };

    btn.setAttribute('aria-busy', 'true');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [item],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);

        var drawer = document.querySelector('cart-drawer');
        var onCartPage = window.location.pathname.indexOf('/cart') === 0;

        if (!onCartPage && drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          syncWrapGuard();
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        errorEl.textContent = err.message || '加入失敗，請重新整理後再試一次。';
        errorEl.hidden = false;
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
      });
  });

  // ---- 商品頁：攔截送出 ----
  // Dawn 的商品表單有 novalidate，瀏覽器原生驗證失效，只能自己擋

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;

      var wrap = document.querySelector('.product__info-container .card-message');
      if (!wrap || wrap.hidden) return;

      var input = wrap.querySelector('.card-message__input');
      if (!input || input.disabled) return;
      if (input.form !== form) return; // 不是這個欄位所屬的表單就不管

      var message = validateMessage(input);
      if (!message) return;

      e.preventDefault();
      e.stopPropagation(); // 攔住，不讓 Dawn 的處理器繼續跑
      showFieldError(wrap, message);
      input.focus();
    },
    true // 捕獲階段，比 Dawn 綁在表單上的監聽器更早執行
  );

  // ---- 結帳擋單：包裝必須搭配商品 ----

  var WRAP_HANDLE = 'rora-premium-gift-wrap-set';
  var CHECKOUT_SELECTOR = '#checkout, #CartDrawer-Checkout';

  function wrapBlockMessage(cart) {
    var wrapQty = 0;
    var otherQty = 0;

    cart.items.forEach(function (item) {
      if (item.handle === WRAP_HANDLE) wrapQty += item.quantity;
      else otherQty += item.quantity;
    });

    if (wrapQty > 0 && otherQty === 0) return '禮盒包裝需搭配商品一同結帳，請先加入飾品。';
    if (wrapQty > otherQty) return '一件飾品限加購 1 份包裝，請調整包裝數量。';
    return null;
  }

  function applyWrapGuard(message) {
    var buttons = document.querySelectorAll(CHECKOUT_SELECTOR);

    Array.prototype.forEach.call(buttons, function (btn) {
      if (message) btn.setAttribute('disabled', 'disabled');
      else btn.removeAttribute('disabled');

      var container = btn.parentNode;
      var notice = container.querySelector('.cart__wrap-warning');

      if (message) {
        if (!notice) {
          notice = document.createElement('p');
          notice.className = 'cart__wrap-warning';
          container.insertBefore(notice, btn);
        }
        notice.textContent = message;
      } else if (notice) {
        notice.parentNode.removeChild(notice);
      }
    });
  }

  function syncWrapGuard() {
    if (!document.querySelector(CHECKOUT_SELECTOR)) return;

    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyWrapGuard(wrapBlockMessage(cart)); })
      .catch(function () {});
  }

  // Dawn 每次更新購物車都會發出 cartUpdate 事件
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(syncWrapGuard, 0);
    });
  }
})();